<div class="image-container">
  <img #profileImage class="hidden profile-image" src="{{ getProfileImageSrc() }}"
    alt="{{ getProfileImageAltText() }}" (error)="onImageLoad(profileImage, personIcon, true)"
    (load)="onImageLoad(profileImage, personIcon, false)" decoding="sync" />
  <div #personIcon class="hidden profile-icon">
    <mat-icon class="icon-start material-symbols-outlined">person</mat-icon>
  </div>
</div>
